import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import KeyIcon from '@mui/icons-material/VpnKey';
import ListIcon from '@mui/icons-material/ListAlt';
import ReportIcon from '@mui/icons-material/ReportGmailerrorred';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const isMaster = (role) => role === 'master' || role === 'admin';

export default function Sidebar({ mobileOpen, onClose, drawerWidth = 260 }) {
  const { user } = useAuth();
  const menu = [
    { to: '/gerar', label: 'Gerar Contra Senha', icon: <KeyIcon /> },
    ...(isMaster(user?.role) ? [{ to: '/senhas', label: 'Senhas Cadastradas', icon: <ListIcon /> }] : []),
    { to: '/ocorrencias', label: 'Ocorrência', icon: <ReportIcon /> },
  ];

  const content = (
    <div>
      <Toolbar />
      <List>
        {menu.map((m) => (
          <ListItem key={m.to} disablePadding>
            <ListItemButton component={NavLink} to={m.to} onClick={onClose}>
              <ListItemIcon>{m.icon}</ListItemIcon>
              <ListItemText primary={m.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <>
      {/* mobile: empurra o conteúdo */}
      <Drawer
        variant="persistent"
        open={mobileOpen}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            top: { xs: 56, sm: 64 },
            height: { xs: 'calc(100% - 56px)', sm: 'calc(100% - 64px)' },
          },
        }}
      >
        {content}
      </Drawer>

      {/* desktop */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
        }}
        open
      >
        {content}
      </Drawer>
    </>
  );
}
